import { plotScale } from '@paige/ui';

export interface MiniTrendLines {
  /** The top of the one scale both lines are drawn on. */
  top: number;
  current: string;
  previous: string;
}

/**
 * A period and the one before as two polylines on ONE scale (0 to the larger of the two), so the lines
 * can be compared by eye. `width` and `height` are the box they are drawn in; a 2px inset keeps the
 * stroke inside it.
 */
export function miniTrend(
  current: readonly number[],
  previous: readonly number[],
  width: number,
  height: number,
): MiniTrendLines {
  const inset = 2;
  const scale = plotScale([...current, ...previous], height - inset * 2, inset);
  const points = (values: readonly number[]) =>
    values
      .map((v, i) => {
        const x = values.length > 1 ? (i / (values.length - 1)) * width : width / 2;
        return `${x.toFixed(1)},${scale.y(Math.max(0, v)).toFixed(1)}`;
      })
      .join(' ');
  return { top: scale.top, current: points(current), previous: points(previous) };
}
